// extracted by mini-css-extract-plugin
export default {"root":"SharingOnboarding__root--2Rf2o","tabDesign":"SharingOnboarding__tabDesign--1ZUmE","animated":"SharingOnboarding__animated--8wRqM"};